import React from 'react';

import { CashPoolProduct } from '@/types/cash-pool.types';
import { FolderTabs } from './FolderTabs';

/**
 * GMRA / GMSLA segment of the cash-pool register.
 *
 * A thin wrapper over the generic `FolderTabs` strip (the collapse the D1 NOTE
 * scheduled for LR-587), kept because the register renders this pair in two
 * places and the pair itself is domain knowledge: GMRA and GMSLA pools are
 * legally separate and never mix.
 */

const PRODUCT_TABS = [
  { key: 'gmra', label: 'GMRA' },
  { key: 'gmsla', label: 'GMSLA' },
] as const;

interface ProductTabsProps {
  active: CashPoolProduct;
  onChange: (product: CashPoolProduct) => void;
}

export const ProductTabs: React.FC<ProductTabsProps> = ({
  active,
  onChange,
}) => (
  <FolderTabs
    tabs={PRODUCT_TABS}
    active={active}
    onChange={onChange}
    ariaLabel="Agreement product"
    idPrefix="cash-pool-product-tab"
  />
);
